/* eslint-disable global-require */
/* eslint-disable import/no-useless-path-segments */
const ASSETS = 'https://virtual-sales-portal-assets.s3-us-west-2.amazonaws.com';
const RSOASSETS = 'https://rso-assets.athum.com';

export const athumLogoLogin = {
  src: `${ASSETS}/atHum-logo.svg`,
  alt: 'AtHUM Logo'
};
export const athumLogo = {
  src: `${ASSETS}/Logo-RedHor%404x+Copy.png`,
  alt: 'AtHUM Logo'
};
export const athumLoader = {
  src: `${ASSETS}/home-white.gif`,
  alt: 'AtHUM Loader'
};
export const athumLogoSVG = {
  src: `${ASSETS}/Logo-RedHor%404x+Copy.svg`,
  alt: 'AtHUM Logo'
};
export const poweredByAtHum = {
  src: `${RSOASSETS}/email-images/PoweredByAtHum.svg`,
  alt: 'Powered by AtHUM'
};
export const homeIcon = {
  src: `${ASSETS}/Icon_house.svg`,
  alt: 'Home'
};
export const homeIconActive = {
  src: `${ASSETS}/Icon_house_active.svg`,
  alt: 'Home'
};
export const interiorsIcon = {
  src: `${ASSETS}/Icon_layout.svg`,
  alt: 'Interiors'
};
export const interiorsIconActive = {
  src: `${ASSETS}/Icon_layout_active.svg`,
  alt: 'Interiors'
};
export const buildingIcon = {
  src: `${ASSETS}/Icon_building.svg`,
  alt: 'Building'
};
export const buildingIconActive = {
  src: `${ASSETS}/Icon_building_active.svg`,
  alt: 'Building'
};
export const amenitiesIcon = {
  src: `${ASSETS}/icon_amenities.svg`,
  alt: 'Amenities'
};
export const amenitiesIconActive = {
  src: `${ASSETS}/icon_amenities_active.svg`,
  alt: 'Amenities'
};
export const neighborhoodIcon = {
  src: `${ASSETS}/icon_neighborhood.svg`,
  alt: 'Neighborhood'
};
export const neighborhoodIconActive = {
  src: `${ASSETS}/icon_neighborhood_active.svg`,
  alt: 'Neighborhood'
};
export const specificationsIcon = {
  src: `${ASSETS}/Icon_tool.svg`,
  alt: 'Specifications'
};
export const specificationsIconActive = {
  src: `${ASSETS}/Icon_tool_active.svg`,
  alt: 'Specifications'
};
export const settingsIcon = {
  src: `${ASSETS}/Icon_Settings.svg`,
  alt: 'Settings'
};
export const settingsIconActive = {
  src: `${ASSETS}/Icon_Settings_active.svg`,
  alt: 'Settings'
};
export const playIcon = {
  src: `${ASSETS}/icon_play.svg`,
  alt: 'Start Session'
};
export const playIconActive = {
  src: `${ASSETS}/icon_play_active.svg`,
  alt: 'Start Session'
};
export const linkIcon = {
  src: `${ASSETS}/Icon_linked.svg`,
  alt: 'Get Session Link'
};
export const deleteIcon = {
  src: `${ASSETS}/Icon_delete.svg`,
  alt: 'Delete Session'
};
export const plusIcon = {
  src: `${ASSETS}/Icon_plus.svg`,
  alt: 'Create New Session'
};
export const closeIcon = {
  src: `${ASSETS}/icon_close.svg`,
  alt: 'Close'
};
export const correctIcon = {
  src: `${ASSETS}/icon_correct.svg`,
  alt: 'Correct'
};
export const dropdownIcon = {
  src: `${ASSETS}/icon_dropdown.svg`,
  alt: 'Dropdown'
};
export const logoutIcon = {
  src: `${ASSETS}/Icon_exit.svg`,
  alt: 'Logout'
};
export const videoLinkIcon = {
  src: `${ASSETS}/Icon_linked_video.svg`,
  alt: 'Link'
};
export const micOnIcon = {
  src: `${ASSETS}/Icon_MicON.svg`,
  alt: 'Mic On'
};
export const videoOnIcon = {
  src: `${ASSETS}/Icon_VideoON.svg`,
  alt: 'Video On'
};
export const speakerOnIcon = {
  src: `${ASSETS}/Icon_SpeakerON.svg`,
  alt: 'Speaker'
};
export const bedroomIcon = {
  src: require('../../src/assets/Icons/icon_bedroom.svg'),
  alt: 'Bedroom'
};
export const bathroomIcon = {
  src: require('../../src/assets/Icons/icon_bathroom.svg'),
  alt: 'Bathroom'
};
export const parkingIcon = {
  src: require('../../src/assets/Icons/icon_car.svg'),
  alt: 'Parking'
};
export const sqmIcon = {
  src: `${ASSETS}/Icon_sqm.svg`,
  alt: 'Square meters'
};
export const moneyIcon = {
  src: `${ASSETS}/Icon_money.svg`,
  alt: 'Price'
};
export const calendarIcon = {
  src: `${ASSETS}/Icon_calendar.svg`,
  alt: 'Availability'
};
export const filtersIcon = {
  src: `${ASSETS}/Icon_filters.svg`,
  alt: 'Filters'
};
export const listWithBulletsIcon = {
  src: `${ASSETS}/Icon_ListBullets.svg`,
  alt: 'List'
};
export const videoOffIcon = {
  src: `${ASSETS}/Icon_VideoOFF_outlined.svg`,
  alt: 'Video Off'
};
export const micOffIcon = {
  src: `${ASSETS}/Icon_MicOFF_outlined.svg`,
  alt: 'Mic Off'
};
export const officeBathroomIcon = {
  src: `${ASSETS}/Icon_office_bathroom.svg`,
  alt: 'Bathrooms'
};
export const backIcon = {
  src: `${ASSETS}/Icon_back.svg`,
  alt: 'Back'
};

export const camIcon = {
  icons: `${RSOASSETS}/Icon_change_camera.svg`,
  alt: 'Camera'
};

export const iconFailed = {
  src: `${ASSETS}/Icon_failed.svg`,
  alt: 'failed'
};

export const mobileErrorImg = {
  src: `${ASSETS}/mobileErrorImage.svg`,
  alt: 'failed'
};

export const desktopErrorImg = {
  404: {
    src: `${ASSETS}/desktopError404Image.svg`,
    alt: 'failed'
  },
  415: {
    src: `${ASSETS}/desktopErrorImage.svg`,
    alt: 'failed'
  }
};

export const sendMessage = {
  src: `${ASSETS}/Icon_SendMessage.svg`,
  alt: 'send message'
};

export const mapButtons = {
  restaurant: {
    title: 'Restaurants',
    iconSelected: `${ASSETS}/Icon_restaurant.svg`,
    icon: `${ASSETS}/Icon_restaurant_coral.svg`
  },
  park: {
    title: 'Parks',
    iconSelected: `${ASSETS}/Icon_parks.svg`,
    icon: `${ASSETS}/Icon_parks_coral.svg`
  },
  shopping_mall: {
    title: 'Shopping centers',
    iconSelected: `${ASSETS}/Icon_shopping.svg`,
    icon: `${ASSETS}/Icon_shopping_coral.svg`
  },
  supermarket: {
    title: 'Supermarkets',
    iconSelected: `${ASSETS}/Icon_supermarket.svg`,
    icon: `${ASSETS}/Icon_supermarket_coral.svg`
  },
  school: {
    title: 'Schools',
    iconSelected: `${ASSETS}/Icon_education.svg`,
    icon: `${ASSETS}/Icon_education_coral.svg`
  },
  bar: {
    title: 'Bar',
    iconSelected: `${ASSETS}/Icon_education.svg`,
    icon: `${ASSETS}/Icon_education_coral.svg`
  }
};

export const background = {
  src: `${ASSETS}/background.png`,
  alt: 'background'
};

export const switchIcon = {
  src: `${ASSETS}/Icon_switch.svg`,
  alt: 'switch'
};

export const shareIcon = {
  src: `${RSOASSETS}/Icon_share.svg`,
  alt: 'share'
};

export const okFilled = {
  src: `${ASSETS}/Icon_OkFilled.svg`,
  alt: 'ok'
};

export const noFilled = {
  src: `${ASSETS}/Icon_NoFilled.svg`,
  alt: 'no'
};

export const panIcon = {
  src: require('../../src/assets/Icons/Icon_pan.svg'),
  alt: 'pan'
};

export const zoomInIcon = {
  src: require('../../src/assets/Icons/Icon_zoomIn.svg'),
  alt: 'zoom in'
};

export const zoomOutIcon = {
  src: require('../../src/assets/Icons/Icon_zoomOut.svg'),
  alt: 'zoom out'
};

export const zoomOutExtents = {
  src: require('../../src/assets/Icons/Icon_zoomOutExtents.svg'),
  alt: 'reset zoom'
};

export const cursorIcon = {
  src: require('../../src/assets/Icons/Icon_cursor.svg'),
  alt: 'cursor'
};

export const areaIcon = {
  src: require('../../src/assets/Icons/icon_area.svg'),
  alt: 'Area'
};

export const levelIcon = {
  src: require('../../src/assets/Icons/Icon_level.svg'),
  alt: 'Area'
};
